let runner = null;
let active = null;
let activeContext = null;

export default {
  register(nextRunner) { runner = nextRunner; },
  unregister(currentRunner) { if (runner === currentRunner) runner = null; },
  check(context) {
    const contextKey = context
      ? `${context.locationId || ''}:${context.stationId || ''}`
      : '';
    if (active) {
      if (activeContext === contextKey) return active;
      return active.then(
        () => this.check(context),
        () => this.check(context),
      );
    }
    if (!runner) return Promise.reject(new Error('Monthly delivery host is unavailable'));
    activeContext = contextKey;
    const currentRunner = runner;
    active = Promise.resolve().then(() => currentRunner(context)).finally(() => {
      active = null;
      activeContext = null;
    });
    return active;
  },
};
